/* Lunaice: „[termin]” → konkretne dni dostawy (przegląd telefonu 2026-10-26, punkt 3). Zamówienie dziś → paczka zwykle
   za 1–4 dni robocze (jak w FAQ „Kiedy dotrze paczka?”), liczone bez sobót, niedziel i świąt ustawowych (stałe daty
   oraz Poniedziałek Wielkanocny i Boże Ciało z daty Wielkanocy). Wynik, np. „wt. 27.10 – pt. 30.10”, trafia do każdego
   <span data-ln-termin>; bez JS zostaje tekst zapasowy ze snippetu („w 1–4 dni robocze”). Szuflada koszyka rysuje się od
   nowa po każdej zmianie koszyka (cart-drawer.js podmienia innerHTML), więc obserwator podmienia także nowe elementy.
   Ładowany z defer przez lunaice-product-benefits.liquid i cart-drawer.liquid; drugie wczytanie nic nie robi.
   Czas liczony w strefie przeglądarki klienta (sklep sprzedaje tylko w Polsce). */
(() => {
  if (window.LunaiceTermin) return;

  const MIN_DAYS = 1;
  const MAX_DAYS = 4;
  const FIXED_HOLIDAYS = ['01-01', '01-06', '05-01', '05-03', '08-15', '11-01', '11-11', '12-25', '12-26'];

  // Wielkanoc (algorytm Meeusa/Jonesa/Butchera), stąd Poniedziałek Wielkanocny (+1) i Boże Ciało (+60)
  const easter = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  };

  const pad = (n) => String(n).padStart(2, '0');
  const key = (date) => `${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  const holidaysByYear = new Map();
  const isHoliday = (date) => {
    const year = date.getFullYear();
    if (!holidaysByYear.has(year)) {
      const set = new Set(FIXED_HOLIDAYS);
      const sunday = easter(year);
      for (const offset of [1, 60]) {
        const moved = new Date(sunday);
        moved.setDate(sunday.getDate() + offset);
        set.add(key(moved));
      }
      holidaysByYear.set(year, set);
    }
    return holidaysByYear.get(year).has(key(date));
  };
  const isBusinessDay = (date) => date.getDay() !== 0 && date.getDay() !== 6 && !isHoliday(date);
  const addBusinessDays = (from, count) => {
    const date = new Date(from);
    let left = count;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      if (isBusinessDay(date)) left -= 1;
    }
    return date;
  };

  // „wt. 27.10”: skrót dnia tygodnia z Intl (pl: pon., wt., śr., czw., pt.) i twarda spacja przed datą
  let weekday;
  try {
    weekday = new Intl.DateTimeFormat('pl-PL', { weekday: 'short' });
  } catch {
    weekday = null;
  }
  const format = (date) => {
    const day = `${date.getDate()}.${pad(date.getMonth() + 1)}`;
    return weekday ? `${weekday.format(date)} ${day}` : day;
  };
  const text = (now = new Date()) => `${format(addBusinessDays(now, MIN_DAYS))} – ${format(addBusinessDays(now, MAX_DAYS))}`;

  const apply = (root) => {
    for (const el of root.querySelectorAll('[data-ln-termin]:not([data-ln-termin="done"])')) {
      el.textContent = text();
      el.dataset.lnTermin = 'done';
    }
  };
  const run = () => apply(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(() => apply(drawer)).observe(drawer, { childList: true, subtree: true });
  }

  window.LunaiceTermin = { text, isBusinessDay };
})();
